import React from 'react';
import FaqItem from '../components/FaqItem';
import { FAQS } from '../data/constants';
import logo from '../images/logo-short.png';

export default function AboutPage({ setPage }) {
  return (
    <main className="page" id="main-content">

      {/* ── PAGE HERO ── */}
      <header className="page-hero">
        <div className="ph-inner">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <ol itemScope itemType="https://schema.org/BreadcrumbList" style={{ listStyle: 'none', display: 'flex', gap: '0.4rem', padding: 0, margin: 0 }}>
              <li itemScope itemType="https://schema.org/ListItem" itemProp="itemListElement">
                <span itemProp="item" onClick={() => { setPage('Home'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
                  <span itemProp="name">Home</span>
                </span>
                <meta itemProp="position" content="1" />
              </li>
              <li aria-hidden="true" className="sep">/</li>
              <li itemScope itemType="https://schema.org/ListItem" itemProp="itemListElement">
                <span itemProp="name" className="cur">About Us</span>
                <meta itemProp="position" content="2" />
              </li>
            </ol>
          </nav>
          <h1>About AQMCS — Assure Quality Management Certification Services</h1>
          <p>NABCB-Accredited Type-A Inspection Body | Trusted Since 2006</p>
        </div>
      </header>

      {/* ── STORY ── */}
      <section className="section" aria-labelledby="story-heading">
        <div className="sec-inner">
          <div className="about-grid">
            {/* Visual card */}
            <div className="about-visual" role="img" aria-label="About Assure Quality Management Certification Services">
              <span className="about-badge">Est. 2006</span>
              <img src={logo} alt="AQMCS — Assure Quality Management Certification Services logo" width="200" height="80" loading="lazy" />
              <h3>20+ Years of Excellence in Audit &amp; Certification</h3>
              <p>
                From a boutique firm to India's trusted inspection body — our story is defined by the thousands of businesses we've helped achieve compliance and quality standards.
              </p>
            </div>

            {/* Story text */}
            <div>
              <div className="sec-tag">About Us</div>
              <h2 className="sec-title" id="story-heading">
                India's Independent &amp; Impartial Inspection Body
              </h2>
              <p style={{ color: 'var(--gray-600)', lineHeight: 1.85, marginBottom: '1.3rem' }}>
                AQMCS is an independent and impartial organisation offering a wide range of services, including inspection, assessment, customised audits, tender document verification, third-party auditing and personnel certification — ensuring compliance with applicable standards and regulatory requirements.
              </p>
              <p style={{ color: 'var(--gray-600)', lineHeight: 1.85, marginBottom: '1.3rem' }}>
                AQMCS has been operating since <strong>2006</strong> and is recognised as a benchmark of honesty, transparency, reliability, quality, impartiality and integrity.
              </p>
              <p style={{ color: 'var(--gray-600)', lineHeight: 1.85, marginBottom: '1.3rem' }}>
                AQMCS is <strong>accredited by NABCB</strong> (member of International Accreditation Forum (IAF), International Laboratory Accreditation Cooperation (ILAC) and Asia Pacific Accreditation Cooperation (APAC), and signatory to their MLAs/MRAs) as a <strong>Type-A Inspection Body in accordance with ISO/IEC 17020</strong>.
              </p>
              <p style={{ color: 'var(--gray-600)', lineHeight: 1.85 }}>
                AQMCS is <strong>recognised by FSSAI</strong> as Hygiene Rating Auditing Agency (HRAA) and Third Party Auditing Agency (TPAA) for food safety audits, and is <strong>empanelled with QCI</strong> as a ZED Assessment Agency under the MSME Sustainable (ZED) Certification Scheme by MoMSME.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── CREDENTIALS ── */}
      <section className="section bg-light" aria-labelledby="creds-heading">
        <div className="sec-inner">
          <div className="sec-tag">Our Credentials</div>
          <h2 className="sec-title" id="creds-heading">Accreditations &amp; Recognitions</h2>
          <div className="services-grid">
            {[
              { icon: '🏛️', title: 'NABCB Accreditation', desc: 'Type-A Inspection Body under ISO/IEC 17020 — internationally recognised through IAF, ILAC and APAC memberships and MLA/MRA signatories.' },
              { icon: '📋', title: 'QCI ZED Assessment Agency', desc: 'Empanelled by Quality Council of India to conduct ZED assessments for MSMEs under the MSME Sustainable (ZED) Certification Scheme.' },
              { icon: '🍽️', title: 'FSSAI HRAA & TPAA', desc: 'Recognised by FSSAI as a Hygiene Rating Auditing Agency (HRAA) and Third Party Auditing Agency (TPAA) for food safety audits.' },
              { icon: '🛢️', title: 'IOCL & NTPC Empanelled', desc: 'Empanelled as a Third Party Inspection Agency (TPIA) with IOCL and NTPC for authentication of tender bidder documents.' },
              { icon: '🛢️', title: 'ONGC Empanelled', desc: 'Empanelled as a Third Party Inspection Agency (TPIA) with with ONGC for authentication/verification of Technical BEC related documents.' },
            ].map((c, i) => (
              <article key={i} className="svc-card">
                <div className="svc-icon">{c.icon}</div>
                <div className="svc-tag">{c.title}</div>
                <h3 className="svc-title">{c.title}</h3>
                <p className="svc-desc">{c.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section
        className="section"
        aria-labelledby="faq2-heading"
        itemScope
        itemType="https://schema.org/FAQPage"
      >
        <div className="sec-inner">
          <div className="sec-tag">Common Questions</div>
          <h2 className="sec-title" id="faq2-heading">Frequently Asked Questions</h2>
          <div className="faq-list">
            {FAQS.slice(0, 3).map((f, i) => (
              <FaqItem key={i} q={f.q} a={f.a} />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
